/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

import {
  IGetCredentialIssuedListProps,
  RevokeCredentialProps,
} from "./components";

const is = require("is_js");

const SERVICE_NAME = "AllEventPageService";
const log: any = LoggerModule.getInstance();

export type IAllEventCredentialPageSrvGetPageContentArgs =
  IGetCredentialIssuedListProps;

export class AllEventPageService {
  private static instance: AllEventPageService;
  private vapp: VApplication;
  private criteria: any;
  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): AllEventPageService {
    if (!AllEventPageService.instance) {
      AllEventPageService.instance = new AllEventPageService(props);
    }
    return AllEventPageService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = [...this.criteria, ...data];
  }

  public resetCriteria() {
    this.criteria = [];
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent(
    args: IAllEventCredentialPageSrvGetPageContentArgs
  ) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if (args?.where) {
      this.setCriteria(args?.where);
    }

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //UserLists Props
    compProps = await agent.getPolicyListsProps({
      ...args,
      where: [...args?.where, ...this.criteria],
    });
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async revokeCred(args: RevokeCredentialProps) {
    console.log(`revoke credential id`, args);
    const agent = getAgent();
    return agent.getRevokeCredential(args);
  }

  public async resendCred(args: RevokeCredentialProps) {
    const agent = getAgent();
    return agent.getResendCredential(args);
  }
}
